import { Heart, Sprout, FileText, Users, UserPlus, ArrowRight, Clock } from "lucide-react";
import { Link } from "react-router-dom";

const VALUES = [
  "Partecipazione",
  "Trasparenza",
  "Collaborazione",
  "Tutela del territorio",
  "Responsabilità civica",
  "Rispetto delle persone e dell'ambiente",
];

export const About = () => {
  return (
    <section
      id="chi-siamo"
      data-testid="about-section"
      className="relative py-24 sm:py-32 bg-[#FBF9F6] overflow-hidden"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #2E4F3B 1px, transparent 1px), radial-gradient(circle at 80% 60%, #2E4F3B 1px, transparent 1px)",
          backgroundSize: "60px 60px, 80px 80px",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B]/10 border border-[#2E4F3B]/20 px-4 py-2 mb-7">
            <Heart className="w-4 h-4 text-[#2E4F3B]" />
            <span className="text-xs sm:text-sm font-bold uppercase tracking-wider text-[#2E4F3B]">
              Chi siamo
            </span>
          </div>

          <h2
            data-testid="about-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-[1.05] tracking-tight"
          >
            Un'associazione di
            <span className="text-[#2E4F3B]"> cittadini</span>,
            <br className="hidden sm:block" />
            per il <span className="text-[#2E4F3B]">futuro</span> del territorio.
          </h2>
        </div>

        {/* Testo principale */}
        <div className="max-w-3xl mx-auto space-y-5 text-lg sm:text-xl text-[#3F3F3F] leading-relaxed">
          <p>
            <strong className="text-[#1A1A1A]">Per Asciano</strong> è
            un'associazione nata nel <strong>2026</strong> dalla volontà di
            alcuni cittadini di contribuire concretamente alla tutela, alla
            valorizzazione e al futuro del territorio di Asciano e del Monte
            Pisano.
          </p>
          <p>
            L'associazione nasce con l'obiettivo di promuovere iniziative utili
            alla comunità, favorire la collaborazione tra cittadini e
            istituzioni e contribuire alla tutela del patrimonio ambientale,
            storico e culturale del territorio.
          </p>
          <p className="text-[#1A1A1A] font-semibold italic">
            Crediamo che il futuro del nostro territorio dipenda dalla
            partecipazione attiva delle persone che lo vivono ogni giorno.
          </p>
        </div>

        {/* Presidente */}
        <div className="mt-16 max-w-3xl mx-auto bg-white border-2 border-[#E5E1D8] rounded-3xl p-7 sm:p-10 shadow-sm">
          <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.22em] text-[#C15C3D] mb-4">
            <Sprout className="w-3.5 h-3.5" />
            Presidente
          </div>
          <h3 className="font-display text-2xl sm:text-3xl font-black text-[#1A1A1A] leading-tight">
            Nicole Innocenti
          </h3>
          <p className="mt-2 text-sm sm:text-base font-semibold text-[#2E4F3B]">
            Fondatrice e Presidente dell'Associazione Per Asciano
          </p>
          <p className="mt-5 text-base text-[#5C5C5C] leading-relaxed">
            Ascianese da qualche generazione — Asciano è la casa della sua
            famiglia. Sempre appassionata alla natura e agli animali, ha
            promosso la nascita dell'associazione con l'obiettivo di creare
            uno spazio di partecipazione civica e di collaborazione tra
            cittadini, professionisti, associazioni e istituzioni per
            contribuire concretamente al bene della comunità.
          </p>
        </div>

        {/* Direttivo — in fase di costituzione */}
        <div
          data-testid="about-direttivo"
          className="mt-8 max-w-3xl mx-auto bg-[#1f2d22] text-white rounded-3xl p-7 sm:p-10 shadow-lg overflow-hidden relative"
        >
          <div className="pointer-events-none absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#E8C9A0]/[0.08] blur-3xl" />
          <div className="relative flex flex-col sm:flex-row gap-6 sm:items-start">
            <div className="w-14 h-14 rounded-2xl bg-[#E8C9A0]/15 border border-[#E8C9A0]/40 flex items-center justify-center shrink-0">
              <Users className="w-7 h-7 text-[#E8C9A0]" strokeWidth={1.6} />
            </div>
            <div className="flex-1">
              <div className="inline-flex items-center gap-2 text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0] mb-3">
                <Clock className="w-3 h-3" />
                In fase di costituzione
              </div>
              <h3 className="font-display text-xl sm:text-2xl font-black leading-tight">
                Il Direttivo dell'associazione
              </h3>
              <p className="mt-3 text-sm sm:text-base text-white/80 leading-relaxed">
                Il Consiglio Direttivo è attualmente <strong className="text-white">in fase
                di costituzione</strong>. Stiamo lavorando insieme ai soci fondatori per
                comporre un organo direttivo solido e rappresentativo del territorio. I
                nomi e i ruoli ufficiali saranno comunicati a breve.
              </p>
              <p className="mt-3 text-sm text-white/70 leading-relaxed italic">
                Vuoi contribuire? Diventa socio e partecipa attivamente alla vita
                dell'associazione.
              </p>
              <Link
                to="/associarsi"
                data-testid="about-direttivo-cta"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-bold text-sm px-6 py-3.5 transition-all shadow-md"
              >
                <UserPlus className="w-4 h-4" />
                Diventa socio
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>

        {/* Valori */}
        <div className="mt-16">
          <div className="text-center mb-9">
            <span className="inline-block text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-[#C15C3D]">
              I nostri valori
            </span>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 max-w-3xl mx-auto">
            {VALUES.map((v) => (
              <span
                key={v}
                data-testid={`value-${v.toLowerCase().replace(/\s/g, "-")}`}
                className="inline-block text-sm sm:text-base font-semibold text-[#2E4F3B] bg-white border-2 border-[#2E4F3B]/20 hover:border-[#2E4F3B]/50 rounded-full px-4 sm:px-5 py-2 sm:py-2.5 transition-colors"
              >
                {v}
              </span>
            ))}
          </div>
        </div>

        {/* Link trasparenza */}
        <div className="mt-14 text-center">
          <Link
            to="/trasparenza"
            data-testid="about-transparency-link"
            className="inline-flex items-center gap-2 text-sm sm:text-base font-bold text-[#1A1A1A] hover:text-[#2E4F3B] underline underline-offset-4 transition-colors"
          >
            <FileText className="w-4 h-4" />
            Trasparenza e documenti dell'associazione
          </Link>
        </div>
      </div>
    </section>
  );
};
